import { render } from "./ShoppingQuickSpentModal.vue?vue&type=template&id=22bef1fc"
import script from "./ShoppingQuickSpentModal.vue?vue&type=script&lang=js"
export * from "./ShoppingQuickSpentModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__